import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CreatableSelect from '../_shared/forms/FormSingleCreatableSelect';

export default class SelectDepartment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            departments: this.props.departments,
            department: this.props.department,
        };
    }

    handleChange = (value) => {
        this.setState({
            department: value,
        });
    };

    render() {
        let error = this.props.error ? this.props.name.split('_').join(' ') + ' is required' : '';
        return (
            <div>
                <CreatableSelect
                    label="Department"
                    options={this.state.departments}
                    handleMultiSelectChange={this.handleChange}
                    classes="form-control"
                    error={error}
                    prefixes={this.state.department}
                    name={this.props.name}
                />
            </div>
        );
    }
}

if (document.getElementById('main-contact-department')) {
    let element = document.getElementById('main-contact-department');

    let department = '';
    if (element.dataset.department !== '') {
        department = JSON.parse(element.dataset.department);
    }

    ReactDOM.render(
        <SelectDepartment
            departments={JSON.parse(element.dataset.departments)}
            department={department}
            name={element.dataset.name}
            error={element.dataset.error}
        />,
        element
    );
}

if (document.getElementById('finance-contact-department')) {
    let element = document.getElementById('finance-contact-department');

    let department = '';
    if (element.dataset.department !== '') {
        department = JSON.parse(element.dataset.department);
    }

    ReactDOM.render(
        <SelectDepartment
            departments={JSON.parse(element.dataset.departments)}
            department={department}
            name={element.dataset.name}
            error={element.dataset.error}
        />,
        element
    );
}

if (document.getElementById('contact-department')) {
    let element = document.getElementById('contact-department');

    let department = '';
    if (element.dataset.department !== '') {
        department = JSON.parse(element.dataset.department);
    }

    ReactDOM.render(
        <SelectDepartment
            departments={JSON.parse(element.dataset.departments)}
            department={department}
            name={element.dataset.name}
            error={element.dataset.error}
        />,
        element
    );
}
